/** Production admin SPA host (custom domain on admin-web-app-worker). */
export const PRODUCTION_ADMIN_HOST = 'admin.embeddables.com'

/** Production API host (custom domain on backend-worker). */
const PRODUCTION_API_HOST = 'backend.embeddables.com'

/** Derive backend-worker URL from admin-web-app-worker hostname (preview deploy convention). */
export function botUrlForAdminHostname(
  hostname: string,
  protocol: string,
  explicitBotUrl?: string,
): string {
  // Branch preview hostnames always pair with matching API — even when the build
  // baked in production VITE_BOT_URL (common in shared CI secrets).
  const branchPreview = hostname.match(/^(.+)-admin-web-app-worker\.(.+)$/)
  if (branchPreview) {
    return `${protocol}//${branchPreview[1]}-backend-worker.${branchPreview[2]}`
  }
  if (hostname === PRODUCTION_ADMIN_HOST) {
    return `${protocol}//${PRODUCTION_API_HOST}`
  }
  if (hostname.startsWith('admin-web-app-worker.')) {
    return `${protocol}//${hostname.replace(/^admin-web-app-worker\./, 'backend-worker.')}`
  }

  const explicit = explicitBotUrl?.replace(/\/$/, '')
  if (explicit) return explicit

  return 'http://127.0.0.1:8787'
}

/** Base URL of the backend-worker Worker. Set VITE_BOT_URL to override. */
export function resolveBotUrl(): string {
  const explicit = import.meta.env.VITE_BOT_URL?.replace(/\/$/, '')
  if (typeof window !== 'undefined') {
    return botUrlForAdminHostname(window.location.hostname, window.location.protocol, explicit)
  }
  return explicit || 'http://127.0.0.1:8787'
}

export const BOT_URL: string = resolveBotUrl()

/** Supabase API URL. Set VITE_SUPABASE_URL to override. */
export const SUPABASE_URL: string = import.meta.env.VITE_SUPABASE_URL || 'http://127.0.0.1:54321'

/** Supabase anon key (printed by `pnpm supabase:start`). */
export const SUPABASE_ANON_KEY: string = import.meta.env.VITE_SUPABASE_ANON_KEY || ''

/**
 * Canonical admin origin loaded inside the auth bridge iframe. Set per deploy so
 * preview satellites can point at a branch-specific bridge host, and update when
 * moving to a production `.com` domain.
 */
export const AUTH_BRIDGE_ORIGIN: string | null =
  import.meta.env.VITE_AUTH_BRIDGE_ORIGIN?.replace(/\/$/, '') || null

/**
 * Optional regex string for hostnames allowed to receive sessions from the bridge
 * page. Defaults to the workers.dev `*-admin-web-app-worker` preview pattern.
 */
export const AUTH_SATELLITE_HOST_PATTERN: string | undefined = import.meta.env
  .VITE_AUTH_SATELLITE_HOST_PATTERN
